import { render, staticRenderFns } from "./IcoSearchPurple.vue?vue&type=template&id=4d6906c6&lang=html"
import script from "./IcoSearchPurple.vue?vue&type=script&lang=js"
export * from "./IcoSearchPurple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports